
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { useLanguage } from '@/context/language-context';
import { useNavigate } from 'react-router-dom';

interface ProfileDetailErrorProps {
  error: string | null;
  onBack: () => void;
}

const ProfileDetailError: React.FC<ProfileDetailErrorProps> = ({ error, onBack }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  
  return (
    <div className="py-8 px-4 max-w-4xl mx-auto">
      <div className="flex items-center mb-6">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={onBack} 
          className="mr-2"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          {t('profile.back')}
        </Button>
      </div>
      
      <Alert className="mb-6" variant="destructive">
        <AlertTitle>Profile Not Found</AlertTitle>
        <AlertDescription>
          {error || "The profile you're looking for doesn't exist or has been removed."}
        </AlertDescription>
      </Alert>
      
      <Button onClick={() => navigate('/explore')}>
        Back to Explore
      </Button>
    </div>
  );
};

export default ProfileDetailError;
